import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  return (
    <>
      {/* Top progress bar */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-orange-500 via-red-500 to-orange-500 origin-left z-50"
        style={{ scaleX }}
      />
      
      {/* Circular progress indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="fixed bottom-8 left-8 w-16 h-16 rounded-full border-2 border-orange-500/30 flex items-center justify-center z-40"
      >
        <svg className="w-full h-full -rotate-90">
          <motion.circle
            cx="32"
            cy="32"
            r="28"
            stroke="#ff5722"
            strokeWidth="2"
            fill="none"
            strokeDasharray="176"
            style={{
              pathLength: scrollYProgress
            }}
          />
        </svg>
        <motion.span
          className="absolute text-orange-500 text-xs font-bold"
          style={{
            opacity: useSpring(scrollYProgress, { stiffness: 100, damping: 30 })
          }}
        >
          {Math.round(scrollYProgress.get() * 100)}%
        </motion.span>
      </motion.div>
    </>
  );
};

export default ScrollProgress;